import React from "react";
import ReportTemplate2 from "../reportTemplate2";
import dayjs from "dayjs";
import { useLocation } from "react-router";
function MaterialUtilizationReport() {
  const location = useLocation();
  const columns: any = [
    {
      title: "Site",
      key: "siteName",
      dataIndex: "siteName",
      width: 100,
    },
    {
      title: "Category",
      dataIndex: "categoryName",
      key: "categoryName",
      width: 200,
    },
    {
      title: "Material Name",
      dataIndex: "materialName",
      key: "materialName",
      width: 200,
    },
    {
      title: "Location",
      key: "location",
      width: 150,
      render: (text: any, record: any) => {
        // For Villa level, only show subUnitName as villa number
        if ((window as any).workBoqData?.workLevel === "Villa") {
          return record.subUnitName || "-";
        }

        // For other levels, build location path
        const location = [];
        if (record.unitName) location.push(record.unitName);
        if (record.floor) location.push(record.floor);
        if (record.subUnitName) location.push(record.subUnitName);
        return (
          <>
            <div className="fw-bold">{location.join(" / ") || "-"}</div>
            <div className="small">
              {(record.locationName && `${record.locationName}`) || ""}
            </div>
          </>
        );
      },
    },
    {
      title: "Issue Date",
      key: "issueDate",
      dataIndex: "issueDate",
      width: 150,
      render: (text: string) => dayjs(text).format("DD-MMM-YYYY HH:mm:ss"),
    },
    {
      title: "Issued By",
      key: "issuedBy",
      dataIndex: "issuedBy",
      width: 100,
    },
    {
      title: "Utilized Date",
      key: "utilizedDate",
      dataIndex: "utilizedDate",
      width: 150,
      render: (text: any) => {
        return text ? dayjs(text).format("DD-MMM-YYYY HH:mm:ss") : "N/A";
      },
    },
    {
      title: "Utilized By",
      key: "utilizedBy",
      dataIndex: "utilizedBy",
      width: 100,
    },
    {
      title: "QTY",
      key: "utilizedQuantity",
      dataIndex: "utilizedQuantity",
      width: 100,
    },
    {
      title: "UOM",
      key: "uomName",
      dataIndex: "uomName",
      width: 100,
    },
    // {
    //   title: "Action",
    //   key: "operation",
    //   // fixed: "right",
    //   width: 150,
    //   render: (text: any, record: any, index: any) => (
    //     <>
    //       <Button
    //         size="sm"
    //         color=""
    //         onClick={() => {
    //           navigate(
    //             `/view-material-issue-details/${record.materialIssueId}`
    //           );
    //         }}
    //       >
    //         <Icon name="focus" />
    //       </Button>
    //     </>
    //   ),
    // },
  ];
  return (
    <ReportTemplate2
      pageTitle="	Material Utilization"
      pageDescription="	Record of materials used for activities at construction sites."
      moduleKey="inventoryMaterialUtilizationReportList"
      columns={columns}
      filtersOption={{
        site: true,
        tower: true,
        floor: true,
        flat: true,
        location: true,
        // contractor: true,
        // dateRange: true,
      }}
      previousPath={
        location.state?.originPath == "InventoryAnalytics"
          ? "/dashboard-inventory"
          : "/view-inventory-reports"
      }
    />
  );
}

export default MaterialUtilizationReport;
